import React, { useState, useEffect, useRef } from "react";

import { Document, Page, pdfjs } from "react-pdf";

export default function MyApp({ url }) {

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <Document
      file={url}
      error="Falha ao buscar arquivo"
      loading="Carregando"
      onLoadSuccess={onDocumentLoadSuccess}
    >
      {Array.apply(null, Array(numPages))
        .map((x, i) => i + 1)
        .map((page) => (
          <Page
            pageNumber={page}
            renderTextLayer={null}
            width={800}
            renderAnnotationLayer={false}
          />
        ))}
    </Document>
  );
}
